import * as React from "react";
import { ReactElement, useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Heading,
  Text,
  Image,
  Button,
  useColorModeValue,
  Container,
  useToast,
  Flex,
  SimpleGrid,
  StackDivider,
  SpaceProps,
  HStack,
  Tag,
  Link,
  Center,
  Grid,
  GridItem,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Skeleton
} from "@chakra-ui/react";
import { PageSlideFade } from "../components/page-transitions";
import { apiHost, baseUrl } from "utils/Cons/Constants";
import axios from "axios";
import { Helmet } from "react-helmet";
import headerBg from "../assets/images/header-background.jpg";
import footerBg from "../assets/images/footer-background.jpg";
import cloudsBg from "../assets/images/cloud-background.png";
import parser from "html-react-parser";
import { MotionBox } from "../components/motion";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { Icon, LatLng } from 'leaflet';
import markerIconPng from "../assets/images/marker-icon.png";
import { CrowdRiffGallery } from 'react-crowdriff-gallery';
import ShareModal from "components/share-modal";

interface TipEvent {
  title: string;
  meta_description?: string;
  slug?: string;
  header_img?: string;
  main_img?: string;
  destination_name?: string;
  destination?: {
    location_latitude: number;
    location_longitude: number;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    slug: string;
  };
  user_data?: {
    display_name: string;
    city: string;
  };
  user_img?: string;
  tip?: string;
}

const markdownTheme = {
  p: props => {
    const { children } = props;
    return (
      <Text mb={2} fontSize={'0.8em'}>
        {children}
      </Text>
    );
  },
};

const Tip = ({ match }) => {
  const toast = useToast();

  const [event, setEvent] = useState<TipEvent>({} as TipEvent);
  const [loading, setLoading] = useState(true);

  const position = [40.9133945, -77.7782867];

  const initialMarkers = [];
  const [markers, setMarkers] = useState(initialMarkers);

  const LocationMarkers = () => {
    return (
      <React.Fragment>
        {markers.map(marker => <Marker
          position={marker.location}
          icon={new Icon({ iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41] })}
          eventHandlers={{
            click: (e) => {
              //setSelectedDestination(marker.data);
              //onOpen();
            },
          }}>
          <Popup>
            <Link href={`/d/${marker.data.slug}`}>{marker.data.name}</Link><br />
            {marker.data.address}<br />
            {marker.data.city}, {marker.data.state} {marker.data.zip}<br />
            <Link href={`tel:+1${marker.data.phone}`}>{marker.data.phone}</Link>
          </Popup>
        </Marker>)}
      </React.Fragment>
    );
  }

  const getEvent = () => {
    let data = {} as TipEvent;
    axios.get(`${apiHost}/tips/get/${match.params.slug}`)
      .then(res => {
        data = res.data;
        console.log(data);
        if (res.status == 200) {
          setEvent(data);

          let geomarkers = [];
          geomarkers.push({ data: data.destination, location: new LatLng(data.destination.location_latitude, data.destination.location_longitude) })
          setMarkers(geomarkers);

          setLoading(false);
        }
        return res;
      })
      .catch(err => {
        setLoading(false);
      });

    return data;
  };

  const showToast = (message, status) => {
    toast({
      position: "bottom",
      description: message,
      status: status,
      duration: 5000,
      isClosable: true
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getEvent();
  }, []);

  return (
    <PageSlideFade>
      <Helmet>
        <title>{event.title}</title>
        <meta name="description" content={event.meta_description} />
      </Helmet>
      {loading && (
        <Container maxW={'5xl'} pt={10} pb={10}>
          <Box>
            <Skeleton height="750px" />
          </Box>
        </Container>
      )}
      {!loading && !event.slug && (
        <Box>
          <Container maxW={'5xl'}>
            <Heading
              as={'h3'}
              fontFamily="american"
              fontWeight={600}
              fontSize={{ base: '2xl', sm: '3xl', md: '4xl' }}
              lineHeight={'100%'}
              textAlign="left"
              mt={{ base: 10, md: 5 }}>
              404 Page Not Found
            </Heading>
            <Box textAlign="left">
              <Button as={Link} href="/">Go to Home Page</Button>
            </Box>
          </Container>
        </Box>
      )}
      
      {!loading && event.slug && (
        <Box>
          {event.header_img != null ? (
            <Box className="home-header-container" backgroundImage={`url(${event.header_img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="60dvh">
              <Container maxW={'5xl'}>

              </Container>
            </Box>
          ) : null}
          <Box bg="#143b49">
            <Container maxW={'5xl'}>
              <Grid templateColumns='repeat(6, 1fr)'>
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <Text
                    as="h1"
                    textAlign="left"
                    fontFamily="american"
                    fontWeight={600}
                    fontSize={{ base: '3xl', sm: '4xl', md: '5xl' }}
                    lineHeight={'100%'}
                    color="#fbeec8"
                    mt={{ base: 4, md: 0 }}
                  >{event.title}</Text>
                </GridItem>
              </Grid>
            </Container>
          </Box>
          <Box bg="#FBEEC8">
            <Container maxW={'5xl'}>
              <Stack direction={{ base: 'column', md: 'row' }}>
                <Box w={{ base: '100%', md: '50%', lg: '65%' }} >
                  <Box>
                    {event.main_img ? (
                      <Image
                        src={`${event.main_img}`}
                        w={'100%'}
                        roundedBottomLeft={20}
                        alt={'main image'}
                      />
                    ) : null}

                  </Box>
                </Box>
                <Box w={{ base: '100%', md: '50%', lg: '35%' }} textAlign="left" bg="white" pl={10} pr={10} pb={10} roundedBottomRight={20}>
                  <Heading
                    as={'h3'}
                    fontFamily="american"
                    fontWeight={600}
                    fontSize={{ base: '2xl', sm: '3xl', md: '4xl' }}
                    lineHeight={'100%'}
                    textAlign="left"
                    mt={{ base: 10, md: 5 }}>
                    {event.destination_name}
                  </Heading>
                  {event.destination ? (
                    <Box>
                      <Text color="gray.500">{event.destination.address}<br />
                        {event.destination.city}, {event.destination.state} {event.destination.zip}</Text>
                      <Link href={`tel:+1${event.destination.phone}`} fontSize="16px;">{event.destination.phone}</Link>
                    </Box>
                  ) : null}
                  {event.user_data ? (
                    <Box>
                      {event.user_img && (
                        <Center>
                          <Image
                            src={`${event.user_img}`}
                            w={'50%'}
                            alt={'photo'}
                          />
                        </Center>
                      )}
                      <Text mt={2}>Tip By <strong>{event.user_data.display_name}</strong> from <strong>{event.user_data.city}</strong></Text>
                    </Box>
                  ) : null}
                  <Box mt={5}>
                    <ShareModal page={event} path="tips/" />
                  </Box>
                </Box>
              </Stack>

              {event.tip != null ? (
                <Box bg="white" className="content-block" mt={5} borderRadius={10} p={4}>
                  {parser(event.tip)}
                </Box>
              ) : null}

            </Container>

              <MapContainer center={position as [number, number]} zoom={10} scrollWheelZoom={false} style={{ minHeight: L.Browser.mobile ? '50vh' : '60vh' }} tap={!L.Browser.mobile} dragging={!L.Browser.mobile}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <LocationMarkers />
              </MapContainer>


          </Box>

        </Box>
      )}
    </PageSlideFade >
  );
};

export default Tip;
